import React from 'react';
import "./index.css";
import { FaAngleRight } from "react-icons/fa";

const Project = () => {
  return (
    <>
      <section className='exp-sec' id='projects'>
        <div className='exp-head'>
          <span>03.</span> Projects
        </div>

        {/* exp body */}
        <div className='exp-div'>
          <div className='job'>
            <span className='job-head'>Blog Page- MERN </span>
            <p className='duration'>March, 2023 - present</p>
            <div className='job-desc'>
              <ul>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Visit- <a href='https://fertileminds.in/' target='_blank'>https://fertileminds.in/</a></p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>My personal dynamic bloging webpage</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Technologies used- React, Node.js and Mongo DB</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Implemented Authentication, dynamic blog post adding, login/signup and deployed on VPS server.</p>
                </li>
              </ul>
            </div>
          </div>
          <div className='job'>
              <span className='job-head'>Tenant Network- Property Listing Website</span>
              <p className='duration'>April, 2023 - May, 2023</p>
              <div className='job-desc'>
                <ul>
                  <li><span className='skills-icon'><FaAngleRight/></span> 
                    <p>Visit- <a href='https://tenantnetwork.in/' target='_blank'>https://tenantnetwork.in/</a></p>
                  </li>
                  <li><span className='skills-icon'><FaAngleRight/></span> 
                    <p>Technologies used- MySQL, React, Node, Express</p>
                  </li>
                  <li><span className='skills-icon'><FaAngleRight/></span> 
                    <p>Fully Dynamic Property Listing Webpage</p>
                  </li>
                  <li><span className='skills-icon'><FaAngleRight/></span> 
                    <p>Implemented Authentication, OTP verification, email verification, Google Cloud Serivces, Razorpay Integration </p>
                  </li>
                  <li><span className='skills-icon'><FaAngleRight/></span> 
                    <p>Deployed on Hostinger VPS server</p>
                  </li>
                </ul>
              </div>
            </div>          
          <div className='job'>
            <span className='job-head'>Helmet Store website- REACT </span>
            <p className='duration'>Sept, 2022</p>
            <div className='job-desc'>
              <ul>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Freelance Project</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Used Hooks, Google Fonts, Material UI, Bootstrap.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Add to Cart Page with checkout functionality.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Project